import { Observable, map } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseRepository } from '@common/data/base';
import { environment } from '@environment/environment';
import { ApiResources } from '@constants/api-resources';
import { ContratoModel, FrotaContratadaModel } from '@data/contrato/models';
import { ContratoStatusModel } from './models/contrato-status.model';

@Injectable()
export class ContratoRepository extends BaseRepository {
  constructor(http: HttpClient) {
    super(http, environment.serverAuthUrl, ApiResources.CONTRATOS);
  }

  filter(search: string) {
    return this.getRequest<{ data: { results: ContratoModel[]; count: number } }>({
      search,
      page: 1,
      offset: 0,
      limit: 10,
    }).pipe(
      map(({ data }) =>
        data.results.map((item) => ({
          label: item.numeroContrato,
          value: item.id,
        })),
      ),
    );
  }

  filterStatus(search: string) {
    return this.customClient.get<{ 
      data: { results: ContratoStatusModel[]; count: number } 
    }>(ApiResources.CONTRATO_STATUS, {
      search,
      page: 1,
      offset: 0,
      limit: 30,
    }).pipe(
      map(({ data }) =>
        data.results.map((item: ContratoStatusModel) => ({
          label: item.descricao,
          value: item.id,
        })),
      ),
    );
  }

  filterVeiculos(search: string) {
    return this.getRequest<{ data: { results: ContratoModel[]; count: number } }>({
      search,
      page: 1,
      offset: 0,
      limit: 100,
    }).pipe(
      map(({ data }) =>
        data.results.map((item) => ({
          label: item.veiculo.placa,
          value: item.veiculo.id,
        })),
      ),
    );
  }

  getFrotaContratada(
    params?: any | HttpParams | HttpParams,
    headers?: any | HttpHeaders
  ): Observable<{ data: { results: FrotaContratadaModel[]; count: number } }> {
    return this.customClient.get<FrotaContratadaModel>(ApiResources.FROTA_CONTRATADA, params, headers).pipe(
      (data: any) => (data ? data : this.handleResponseRequest(data))
    );
  }

  vincularCondutor(contratoId: string, condutorId: string) {
    const body = {
      codigoContrato: contratoId,
      codigoCondutor: condutorId
    }

    return this.customClient.post(ApiResources.CONDUTOR_CONTRATO, body).pipe(
      (data: any) => (data ? data : this.handleResponseRequest(data))
    );
  }

  desvincularCondutor(contratoId: string, condutorId: string) {
    const body = {
      codigoContrato: contratoId,
      codigoCondutor: condutorId
    }

    return this.customClient.put(ApiResources.CONDUTOR_CONTRATO, body).pipe(
      (data: any) => (data ? data : this.handleResponseRequest(data))
    );
  }
}
